const ICONS = {
    HOME: require("src/assets/icons/home-icon.png"),
    GROUND: require("src/assets/icons/ground-icon.png"),
    MY_PROFILE: require("src/assets/icons/my-profile-icon.png"),
    SEARCH: require("src/assets/icons/search-icon.png"),
    TEAM_PROFILE: require("src/assets/icons/team-profile-icon.png"),
    BLOG: require("src/assets/icons/blog.png"),
    INSTAGRAM: require("src/assets/icons/instagram.png"),

};

export default ICONS;
